/**
 * @generated SignedSource<<d88eda259dd5a1edd1f299fb3e2a8965>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type postHeader_unpinPostMutation$variables = {
  id: string;
};
export type postHeader_unpinPostMutation$data = {
  readonly unpinPost: {
    readonly id: string;
  };
};
export type postHeader_unpinPostMutation = {
  response: postHeader_unpinPostMutation$data;
  variables: postHeader_unpinPostMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postHeader_unpinPostMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "unpinPost",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postHeader_unpinPostMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "unpinPost",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea6e51a669769baf5b3e28548160d532",
    "id": null,
    "metadata": {},
    "name": "postHeader_unpinPostMutation",
    "operationKind": "mutation",
    "text": "mutation postHeader_unpinPostMutation(\n  $id: ID!\n) {\n  unpinPost(id: $id) {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6cf58a345b586a35f9c5b659132c8a0";

export default node;
